// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"3":"templates","7":"generate","340":"overview","536":"new","922":"edit","957":"append"}[chunkId] || chunkId) + "-legacy." + {"3":"01b96372","7":"a3fb3d73","69":"d68124f8","238":"3b793a88","340":"f673c6bf","404":"a4699526","536":"9c963da1","922":"93b0c2ee","957":"accc3fdb"}[chunkId] + ".js";
};